
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import LogAuthorization from '@/views/Authorization/components/logAuthorization/logAuthorization.vue'
import LogProject from '@/views/Project/Project/components/logProject/logProject.vue'
import LogObservation from '@/views/Project/Observation/components/logObservation/logObservation.vue'
import LogComment from '@/views/Project/Comment/components/logComment/logComment.vue'
import LogPsi from '@/views/Project/PSI/components/log.vue'
import ContractorsLog from '@/views/Project/ch/components/Log/logItem.vue'

import NotificationModel from '@/views/Notification/models/notification'

const NotificationComponent = Vue.extend({
    mixins: [AppMixin],
    components: {
        LogAuthorization,
        LogProject,
        LogObservation,
        LogComment,
        ContractorsLog,
        LogPsi,
    },
    props: { notification: NotificationModel },
    data: () => ({
        loadingMarkAsRead: false,
    }),

    methods: {
        async markAsRead() {
            this.loadingMarkAsRead = true

            let res = await this.notification.markAsRead().catch(() => {
                //
            })

            this.loadingMarkAsRead = false

            if (res) {
                if (this.notification.read && !this.$store.getters.hasUnreadNotifications) {
                    this.$store.commit('hasUnreadNotifications', true)
                }
                this.$emit('markedAsRead')
            }
        },
    },
})

export default NotificationComponent
